import {
  Component,
  Input,
  ViewChild
} from '@angular/core';
import {
  ControlContainer,
  NgForm,
  NgModel
} from '@angular/forms';

import { CompanyCountryValidationsModel } from '../../../companies/models/company.country-validations';
import { PhoneValidator }                 from '../../validators/phone.validator';
import { TextControlComponent }           from '../text-control/text-control.component';
import { trimOnBlur }                     from '../trim-on-blur';

@Component({
  selector   : 'wor-phone-control',
  template: require('./phone-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class PhoneControlComponent extends TextControlComponent {
  // Replaces the invalid phone or mobile text.
  @Input() invalidMessage ?: string;
  // The AngularJS field: the error shows on load and only a matching number is reduced to its digits.
  @Input() isLegacy        = false;
  @Input() isMobile        = false;
  @Input() maxlength       = 30;
  @Input() validations     : CompanyCountryValidationsModel;

  @ViewChild('phone')        phoneModel     : NgModel;
  @ViewChild(PhoneValidator) phoneValidator : PhoneValidator;

  handleModelChange ( _model : string ) : void {
    if ( !this.isLegacy ) {
      this.modelChange.emit(_model?.replace(/\D/g,''));

      return;
    }

    const typed = ( _model || '' ).trim();

    const match = this.phoneValidator?.mask
      ? typed.match(this.phoneValidator.regex)
      : null;

    this.modelChange.emit(match ? match.slice(1).join('') : typed);
  }

  onBlur ( event : FocusEvent ) : void {
    if ( this.isLegacy ) {
      trimOnBlur(this.phoneModel);
    }

    this.blur.emit(event);
  }

  showsError ( phone : NgModel ) : boolean {
    return phone.control.invalid && ( phone.control.dirty || this.isLegacy );
  }
}
